import { j as o } from "../../jsx-runtime-Wav_3Wde.js";
import s from "../BaseIcon.mjs";
const a = (r) => /* @__PURE__ */ o.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Card",
  ...r,
  children: /* @__PURE__ */ o.jsx("g", {
    children: /* @__PURE__ */ o.jsx("path", {
      d: "M0.99,9V7c0-1.1,0.9-2,2-2h18c1.1,0,2,0.9,2,2v2H0.99z M0.99,11v6c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2v-6   H0.99z"
    })
  })
}), t = (r) => /* @__PURE__ */ o.jsx(s, {
  IconSvg: a,
  ...r
});
export {
  t as default
};
